import { getAgencies } from '../../api/agencies';
import { getRealtors } from '../../api/realtors';
import { TThunkAction } from '../../types/redux';
import { ETabs } from '../../types/redux/tabs';
import { getQueryString } from '../../utils/getQueryString';
import { setAgenciesItems, setRealtorItems, setAgenciesLoading, setRealtorsLoading } from '../listing';

export function getNewPageRealtors(pageNum: number): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const {
      realtors: {
        filters,
        listing: { limit },
      },
      geo: { locationsMap },
    } = getState();
    // oxlint-disable-next-line typescript/no-non-null-assertion
    const regionId = locationsMap[ETabs.Realtors]!.id;
    const parameters = {
      ...filters,
      regionId,
      page: pageNum,
    };

    dispatch(setRealtorsLoading(true));

    // TODO: Вторую пустую строку заменить на реальный document title CD-100235
    window.history.pushState('', '', getQueryString(ETabs.Realtors, pageNum, parameters));

    const response = await getRealtors(context, { ...parameters, limit });

    dispatch(
      setRealtorItems({
        ...response,
        page: pageNum,
      }),
    );
  };
}

export function getNewPageAgencies(pageNum: number): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const {
      agencies: {
        filters,
        listing: { limit },
      },
      geo: { locationsMap },
    } = getState();
    // oxlint-disable-next-line typescript/no-non-null-assertion
    const regionId = locationsMap[ETabs.Agencies]!.id;
    const parameters = {
      ...filters,
      regionId,
      page: pageNum,
    };

    dispatch(setAgenciesLoading(true));

    // TODO: Вторую пустую строку заменить на реальный document title CD-100235
    window.history.pushState('', '', getQueryString(ETabs.Agencies, pageNum, parameters));

    const response = await getAgencies(context, { ...parameters, limit });

    dispatch(
      setAgenciesItems({
        ...response,
        page: pageNum,
      }),
    );
  };
}
